import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { toRefs } from 'vue';

import { MyOrdersListType } from '@exchange/libs/order/shared-model/src/lib/order-essentials';

import DivTable from '../../components/DivTable.vue';
import InfoMessageBlock from '../../components/InfoMessageBlock.vue';
import OrdersItemDesktop from '../../components/OrdersItemDesktop.vue';
import { useOrdersListActive, useOrdersListDesktop } from '../../useOrdersList';

const tableSortingKey = 'MY_ORDERS_OPEN_SORTING';

export default /*#__PURE__*/_defineComponent({
  __name: 'OpenOrdersListDesktop',
  props: {
  authenticatedUser: { type: Boolean, required: true },
  breakpoint: { type: String, required: true },
  dragging: { type: Boolean, required: true },
  marketId: { type: String, required: true },
  showAllMarkets: { type: Boolean, required: true },
  showOrderType: { type: Boolean, required: true },
},
  setup(__props) {

const props = __props;

const { breakpoint: breakpointRef, showOrderType: showOrderTypeRef, marketId } = toRefs(props);

const type = MyOrdersListType.open;

const { activeOrdersDataToShow, getOrderById, getLimitedActiveOrdersDataToShow } = useOrdersListActive(marketId);
const { desktopHeader, saveSorting, cancelOrder } = useOrdersListDesktop(MyOrdersListType.open, tableSortingKey, breakpointRef, showOrderTypeRef);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DivTable, {
    class: _normalizeClass(["open-orders-list-desktop", __props.breakpoint]),
    header: _unref(desktopHeader),
    rows: _unref(activeOrdersDataToShow).allOrders,
    "sticky-header": true,
    onHeaderChanged: _cache[0] || (_cache[0] = ($event: any) => (_unref(saveSorting)($event)))
  }, {
    default: _withCtx(({ rows }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getLimitedActiveOrdersDataToShow)(rows), (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (_unref(getOrderById)(item.orderId))
            ? (_openBlock(), _createBlock(OrdersItemDesktop, {
                key: item.key,
                class: _normalizeClass(["open-orders-list-desktop__row", __props.breakpoint]),
                "is-current-market-order": _unref(marketId) === item.instrumentCode,
                "show-order-type": __props.showOrderType,
                order: _unref(getOrderById)(item.orderId),
                type: _unref(type),
                "cancel-order": _unref(cancelOrder),
                "is-futures": item.instrumentCode.endsWith('_P')
              }, null, 8, ["is-current-market-order", "show-order-type", "order", "type", "class", "cancel-order", "is-futures"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 256)),
      (!rows.length)
        ? (_openBlock(), _createBlock(InfoMessageBlock, {
            key: 0,
            class: "open-orders-list-desktop__info",
            "market-id": _unref(marketId),
            "show-all-markets": __props.showAllMarkets,
            "authenticated-user": __props.authenticatedUser
          }, null, 8, ["market-id", "show-all-markets", "authenticated-user"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "header", "rows"]))
}
}

})